import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { useSite } from "@/context/SiteContext";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { site } = useSite();
  const { team_name, logo_url } = site.content;

  const linkClass = ({ isActive }) =>
    `px-2 xl:px-3 py-2 text-[13px] xl:text-sm font-semibold uppercase tracking-wide transition-colors whitespace-nowrap ${
      isActive ? "text-[#0F4C2A] border-b-2 border-[#D97706]" : "text-slate-600 hover:text-[#0F4C2A]"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-xl border-b border-slate-200 shadow-sm" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Link to="/" className="flex items-center gap-3" data-testid="nav-brand-logo" onClick={() => setOpen(false)}>
            <img src={logo_url} alt="Team logo" className="h-10 w-10 sm:h-12 sm:w-12 rounded-full object-cover ring-2 ring-[#0F4C2A]/20" />
            <div className="leading-tight">
              <span className="font-condensed block text-lg sm:text-xl font-extrabold uppercase tracking-tight text-[#0F4C2A]">{team_name}</span>
              <span className="block text-[10px] sm:text-xs font-semibold uppercase tracking-[0.2em] text-[#D97706]">Norwalk High School</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
            {NAV_LINKS.map((l) => (
              <NavLink key={l.path} to={l.path} className={linkClass} data-testid={l.testid} end={l.path === "/"}>
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/schedule"
              data-testid="nav-cta-schedule"
              className="ml-3 bg-[#0F4C2A] text-white hover:bg-[#0A3823] px-5 py-2.5 rounded-md font-bold text-sm tracking-wide uppercase transition-colors shadow-md hover:shadow-lg"
            >
              Game Schedule
            </Link>
          </nav>

          <button
            className="lg:hidden p-2 text-[#0F4C2A]"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-button"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-nav">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              end={l.path === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-${l.testid}`}
              className={({ isActive }) =>
                `block px-6 py-3.5 text-sm font-bold uppercase tracking-wide border-b border-slate-100 ${
                  isActive ? "text-[#0F4C2A] bg-[#0F4C2A]/5 border-l-4 border-l-[#D97706]" : "text-slate-600"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
